// extracted by mini-css-extract-plugin
export default {"Vcard":"VirtualAccount_Vcard__-pXKR","VAcctTxt":"VirtualAccount_VAcctTxt__m0SDW","VFundTxt":"VirtualAccount_VFundTxt__tzBLY","VBank":"VirtualAccount_VBank__G6Zlm"};